import { render, staticRenderFns } from "./verify.vue?vue&type=template&id=3fce6042&scoped=true"
import script from "./verify.vue?vue&type=script&lang=js"
export * from "./verify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fce6042",
  null
  
)

export default component.exports